"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// this function is used for OpenFeature and should not break, so it handles an optional UserInfo even though UserInfo should always be present before context is sent to OpenFeature
const openFeatureUserContext = (userInfo) => {
    if (!userInfo) {
        return {};
    }
    else {
        const environment = process.env.MLC_ENV || 'local';
        return {
            kind: 'user',
            key: userInfo.id || '',
            email: userInfo.email,
            firstName: userInfo.firstName,
            lastName: userInfo.lastName,
            groups: getGroups(userInfo),
            environment: environment,
        };
    }
};
const getGroups = (userInfo) => {
    let groups = [userInfo.isInternalUser ? 'internal' : 'user'];
    if (userInfo.groups) {
        groups = [...groups, ...userInfo.groups.map((group) => group.name)];
    }
    if (userInfo.permissions) {
        groups = [...groups, ...userInfo.permissions.map((permission) => permission.name)];
    }
    return groups;
};
exports.default = openFeatureUserContext;
